import { render, staticRenderFns } from "./DocumentCategoryEdit.vue?vue&type=template&id=6ef15fed&"
import script from "./DocumentCategoryEdit.vue?vue&type=script&lang=ts&"
export * from "./DocumentCategoryEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports